/** Every user-facing string on the Integrations landing and the vendor lock card (spec §4). */
export const landingCopy = {
  header: 'Integrations',
  firstRun: {
    headline: 'Connect your property management software',
    subline:
      'Pick your PMS to get started. Properties sync into PlanOmatic for one-click ordering, and finished photos deliver straight back to your platform.',
    setUp: 'Set Up',
    learnMore: 'Learn More',
  },
  hero: {
    pill: { active: 'Active', disabled: 'Disabled', inactive: 'Inactive', refreshFailed: 'Refresh failed' },
    message: {
      disabled:
        'Syncing is paused. Re-enabling revalidates your saved credentials and runs a full property refresh.',
    },
    reenableFailedTitle: 'Re-enable failed',
    refreshRequestFailed: {
      title: 'Refresh failed',
      body: 'The property refresh could not be started. Try again in a moment.',
    },
    facts: {
      connectedOn: 'Connected on',
      enabledBy: 'Enabled by',
      enabledOn: 'Enabled on',
      disabledBy: 'Disabled by',
      disabledOn: 'Disabled on',
      lastRefresh: 'Last property refresh',
    },
    actions: {
      refresh: 'Refresh Data',
      settings: 'Settings',
      viewSettings: 'View Settings',
      reenable: 'Re-enable',
      reenabling: 'Validating…',
    },
    sync: {
      running: 'Property sync in progress. New properties appear as they arrive.',
      complete: 'Property sync complete.',
      failed: 'The last property refresh failed. Check the connection and try again.',
      viewProperties: 'View properties',
    },
    chips: {
      autoSync: 'Auto-Sync Assets',
      watermark: 'Watermarked Photos',
      on: 'On',
      off: 'Off',
    },
  },
  directory: {
    heading: 'More integrations',
    note: 'One PMS connection per organization. Need to switch? Contact support@planomatic.com.',
    lockedWhileConnected: (connected: string) => `Unavailable while ${connected} is connected`,
    lockedWhileDisabled: (connected: string) => `${connected} remains your PMS while disabled.`,
    comingSoon: 'Coming Soon',
    interested: 'Tell us you’re interested',
  },
  footer: {
    prompt: 'Using another property management application?',
    cta: 'Tell us about it',
  },
  lock: {
    title: (vendor: string) => `${vendor} can't be connected`,
    body: (connected: string) =>
      `${connected} is your organization's PMS integration. Only ${connected} can be re-enabled. To switch platforms, contact support@planomatic.com.`,
    back: 'Back to Integrations',
  },
} as const;
